<template lang="pug">
.checkboxSelectOptionComponent(
  @click="onClick",
  :class="optionClasses"
)
  ui-checkbox(
    v-model="checked"
    :labelText="option.label"
  )
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      default: null
    },
    isSelected: Boolean,
    isDisabled: Boolean
  },
  emits: ['select', 'deselect'],
  data () {
    return {
      checked: false
    }
  },
  computed: {
    optionClasses () {
      return {
        _selected: this.isSelected,
        _disabled: this.isDisabled
      }
    }
  },
  watch: {
    isSelected: {
      handler (val) {
        this.checked = val
      },
      deep: true
    }
  },
  methods: {
    onClick () {
      if (!this.option.isDisabled) this.$emit(this.option.isSelected ? 'deselect' : 'select', this.option.id)
    }
  }
}
</script>

<style lang="sass" scoped>
.checkboxSelectOptionComponent
  color: $cText
  cursor: pointer
</style>
